const readStoredColumnLayout = (columnConfigKey) => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  try {
    const stored = window.localStorage.getItem(columnConfigKey);
    if (!stored) return null;

    const parsed = JSON.parse(stored);
    if (!parsed || typeof parsed !== 'object') return null;

    return parsed;
  } catch (error) {
    return null;
  }
};

const isColumnVisible = (columnVisibility, columnId) => {
  if (!columnVisibility || typeof columnVisibility !== 'object') {
    return true;
  }

  if (!Object.prototype.hasOwnProperty.call(columnVisibility, columnId)) {
    return true;
  }

  return columnVisibility[columnId] !== false;
};

const filterExportableColumnIds = (columnIds, naoExportaveis) => {
  const blocked = new Set(naoExportaveis || []);

  return (columnIds || []).filter((columnId) => columnId && !blocked.has(columnId));
};

const resolveSourceOrder = ({
  columnOrder,
  columnIds,
  todasIds,
  padraoVisiveis
}) => {
  if (Array.isArray(columnOrder) && columnOrder.length > 0) {
    return columnOrder;
  }

  if (Array.isArray(columnIds) && columnIds.length > 0) {
    return columnIds;
  }

  if (Array.isArray(todasIds) && todasIds.length > 0) {
    return todasIds;
  }

  return padraoVisiveis || [];
};

const hasLayoutSignals = ({ columnOrder, columnIds, columnVisibility }) => (
  (Array.isArray(columnOrder) && columnOrder.length > 0)
  || (Array.isArray(columnIds) && columnIds.length > 0)
  || (columnVisibility && Object.keys(columnVisibility).length > 0)
);

export const resolveColunasExportacaoFromLayout = ({
  columnOrder,
  columnVisibility,
  columnIds,
  visibleColumnIds,
  todasIds,
  padraoVisiveis,
  naoExportaveis
}) => {
  const fallback = filterExportableColumnIds(padraoVisiveis, naoExportaveis);

  if (hasLayoutSignals({ columnOrder, columnIds, columnVisibility })) {
    const sourceOrder = resolveSourceOrder({
      columnOrder,
      columnIds,
      todasIds,
      padraoVisiveis: fallback
    });

    const visibleIds = filterExportableColumnIds(
      sourceOrder.filter((columnId) => isColumnVisible(columnVisibility, columnId)),
      naoExportaveis
    );

    if (visibleIds.length > 0) {
      return visibleIds;
    }
  }

  if (Array.isArray(visibleColumnIds) && visibleColumnIds.length > 0) {
    const fromConfig = filterExportableColumnIds(visibleColumnIds, naoExportaveis);
    if (fromConfig.length > 0) {
      return fromConfig;
    }
  }

  return fallback;
};

export const resolveColunasExportacao = ({
  columnConfigKey,
  padraoVisiveis,
  naoExportaveis,
  todasIds,
  layout,
  visibleColumnIds
}) => {
  const storedLayout = layout || readStoredColumnLayout(columnConfigKey);

  return resolveColunasExportacaoFromLayout({
    columnOrder: storedLayout?.columnOrder,
    columnVisibility: storedLayout?.columnVisibility,
    columnIds: storedLayout?.columnIds,
    visibleColumnIds,
    todasIds,
    padraoVisiveis,
    naoExportaveis
  });
};
